<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
    <path
      d="M22.8535 9.78711C23.2887 8.78351 24.7113 8.78351 25.1465 9.78711L27.6973 15.668C28.2407 16.921 29.4226 17.7796 30.7822 17.9092L37.1631 18.5176C38.252 18.6213 38.6919 19.9742 37.8721 20.6982L33.0664 24.9414C32.0428 25.8453 31.5919 27.2344 31.8887 28.5674L33.2822 34.8252C33.5197 35.8927 32.3686 36.7288 31.4268 36.1729L25.9062 32.9141C24.7302 32.2198 23.2698 32.2198 22.0938 32.9141L16.5732 36.1729C15.6314 36.7288 14.4803 35.8927 14.7178 34.8252L16.1113 28.5674C16.4081 27.2344 15.9572 25.8453 14.9336 24.9414L10.1279 20.6982C9.30809 19.9742 9.748 18.6213 10.8369 18.5176L17.2178 17.9092C18.5774 17.7796 19.7593 16.921 20.3027 15.668L22.8535 9.78711Z"
      stroke="#DCDAE5"
      stroke-width="2.5"
    />
  </svg>
</template>
